/* eslint-disable import/prefer-default-export */

export const getMonthDiff = (from, to) => {
  const date1 = new Date(from);
  const date2 = new Date(to);
  const diff = Math.round((date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24 * 30));
  return `${diff} Months`;
};
